import React from "react";

const SupportPanelsComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default SupportPanelsComponent;
